import {IRegulationService} from './regulation.service.interface';
import {RegulationBase} from './regulation-base';
import {observable} from 'mobx';
import {Italy} from './regulations/italy';
import {Spain} from './regulations/spain';
import {Romania} from './regulations/romania';
import {LauncherServiceBase} from '../launcher-service-base';
import {Gibraltar} from './regulations/gibraltar';
import {UK} from './regulations/uk';
import {Malta} from './regulations/malta';
import {Denmark} from './regulations/denmark';
import {Portugal} from './regulations/portugal';
import {Sweden} from './regulations/sweden';
import {NewJersey} from './regulations/new-jersey';
import {Delaware} from "./regulations/delaware";
import {Germany} from "./regulations/germany";

export class RegulationService extends LauncherServiceBase implements IRegulationService {


    /*
        to add presets for
        title: 'CIP (COM)',
        title: 'CIS (COM)',
        title: 'NJ - Harrhas',
        title: 'NJ - Rio',
     */

    @observable.ref
    items: RegulationBase[] = [
        new Denmark(this.services),
        new Germany(this.services),
        new Gibraltar(this.services),
        new Italy(this.services),
        new Malta(this.services),
        new NewJersey(this.services),
        new Delaware(this.services),
        new Portugal(this.services),
        new Romania(this.services),
        new Spain(this.services),
        new Sweden(this.services),
        new UK(this.services),
    ];

}
